
<template>
  <div>
<template id="my-select">
  <select>
    <option v-for="(value, index) in options" :value="value.value" v-bind:key = "index">
      {{ value.label }}
    </option>
  </select>
</template>
  </div>
</template>

<script>
    export default {
        name: 'MySelect',
        props: {
            options: {
                type: Array,
                required: true,
            },
            default: {
                type: String,
                required: false,
                default: null,
            },
            tabindex: {
                type: Number,
                required: false,
                default: 0,
            },
        },
        data() {
            return {
            selected: this.default
                ? this.default
                : this.options.length > 0
                ? this.options[0]
                : null,
            open: false,
            };
        },
        mounted() {
            this.$emit("input", this.selected);
        },
    };
</script>

<style lang="scss" scoped>

.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 47px;
  line-height: 47px;
}

.custom-select .selected {
  background-color: fff;
  border-radius: 6px;
  border: 1px solid #666666;
  color: #000;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}

.custom-select .selected.open {
  border: 1px solid #ad8225;
  border-radius: 6px 6px 0px 0px;
  background: red;
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 22px;
  right: 1em;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #fff transparent transparent transparent;
}

.custom-select .items {
  color: #000;
  border-radius: 0px 0px 6px 6px;
  overflow: hidden;
  border-right: 1px solid #ad8225;
  border-left: 1px solid #ad8225;
  border-bottom: 1px solid #ad8225;
  position: absolute;
  background-color: yellow;
  left: 0;
  right: 0;
  z-index: 1;
  width: 1200px;;

}

.custom-select .items div {
  color: #000;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}

.custom-select .items div:hover {
  background-color: #b4d3f5;
  color: #000;
}

.selectHide {
  display: none;
}
</style>